function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M161.873,153.522c-0.076-3.503-0.859-6.831-2.159-9.883c-2.97,4.411-7.071,8.142-12.167,10.671 c-0.609,0.299-1.235,0.533-1.855,0.794l20.467,153.958h-62.147l11.999-89.935c-2.448,6.103-4.835,11.906-7.12,17.253 c-7.533,17.633-12.472,27.299-15.996,32.64l-7.517,56.36h99.41L161.873,153.522z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M108.587,151.161c0.441-1.316,0.903-2.654,1.349-3.976c-0.163-0.18-0.299-0.392-0.457-0.577 C109.049,148.083,108.761,149.6,108.587,151.161z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.734,0.178c-4.313,3.247,25.346,50.023,67.368,106.687c2.883-3.856,6.657-7.125,11.259-9.41 c1.898-0.941,3.867-1.643,5.874-2.187C82.147,38.79,45.069-3.085,40.734,0.178z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M285.035,87.448c-1.382-5.216-56.011,4.65-124.386,22.235c0.413,0.696,0.865,1.365,1.229,2.105 c2.883,5.809,3.802,12.086,3.03,18.085C233.533,111.271,286.422,92.691,285.035,87.448z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84.269,270.146c1.86,0,5.608-5.836,10.617-16.045c6.396-13.037,14.865-33.244,24.16-57.73 c4.563-12.015,9.323-25.052,14.131-38.775c-3.03-0.027-5.978-0.473-8.784-1.3c-3.666-1.082-7.049-2.85-10.068-5.14 c-3.443,10.247-6.679,20.168-9.665,29.632c-15.953,50.556-24.824,87.884-20.658,89.315 C84.089,270.135,84.176,270.146,84.269,270.146z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M112.013,141.066c0.625,0.887,1.3,1.73,2.018,2.518c0.674,0.745,1.409,1.414,2.159,2.067 c2.654,2.317,5.722,4.041,9.013,5.129c2.66,0.881,5.439,1.392,8.273,1.392c0.544,0,1.088-0.06,1.632-0.092 c1.001-0.06,2.002-0.185,2.997-0.364c1.055-0.19,2.099-0.446,3.144-0.767c1.115-0.348,2.214-0.761,3.301-1.267 c0.196-0.092,0.392-0.152,0.587-0.25c5.102-2.529,8.969-6.516,11.46-11.183c1.142-2.138,1.92-4.433,2.437-6.793 c1.235-5.635,0.745-11.683-2.018-17.253c-0.544-1.093-1.159-2.121-1.828-3.106c-4.977-7.332-13.211-11.515-21.745-11.515 c-1.528,0-3.057,0.174-4.585,0.446c-2.399,0.43-4.781,1.159-7.071,2.295c-4.34,2.154-7.729,5.401-10.209,9.176 c-4.944,7.544-5.967,17.383-1.67,26.053c0.593,1.191,1.267,2.312,2.007,3.372C111.937,140.979,111.981,141.018,112.013,141.066z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function Svg1012(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 325.38 325.38",
    fill: "inherit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1012);
export default __webpack_public_path__ + "static/media/10_12.1dcc8295.svg";
export { ForwardRef as ReactComponent };